import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store'; // FIX: Changed to a named import
import { Toaster } from './components/ui/toaster';
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
        <HelmetProvider>
      <App />
      <Toaster />
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);